/* Nora Janne: houdt de kortingsbalk, het aantal en het totaal in de afrekenknop bij
   nadat het winkelmandje verandert (toevoegen, aantal wijzigen, verwijderen). */
(function () {
  var bezig = false, opnieuw = false;
  function geld(cent) {
    try { return theme.Currency.formatMoney(cent, theme.settings.moneyFormat); }
    catch (e) { return '€' + (cent / 100).toFixed(2).replace('.', ','); }
  }
  // De teksten komen uit het taalbestand (nj.staffel.*) via data-t-* op de balk
  function t(naam) { var b = document.querySelector('[data-nj-staffel]'); return (b && b.getAttribute('data-t-' + naam)) || ''; }
  function tekst(n) {
    if (n >= 4) return t('max');
    if (n === 3) return t('drie');
    if (n === 2) return t('twee');
    if (n === 1) return t('een');
    return t('nul');
  }
  function teken(cart) {
    var b0 = document.querySelector('[data-nj-staffel]');
    var uit = ((b0 && b0.getAttribute('data-uitgesloten')) || '').split(',').filter(Boolean).map(Number);
    var n = (cart.items || []).reduce(function (s, i) { return (uit.indexOf(i.product_id) >= 0 || (i.properties && i.properties._nj_cadeau === '1')) ? s : s + i.quantity; }, 0);
    document.querySelectorAll('[data-nj-staffel]').forEach(function (b) {
      var t = b.querySelector('[data-nj-staffel-tekst]'); if (t) t.innerHTML = tekst(n);
      b.querySelectorAll('[data-nj-stuk]').forEach(function (s) { s.classList.toggle('is-aan', n >= +s.getAttribute('data-nj-stuk')); });
      b.querySelectorAll('[data-nj-label]').forEach(function (s) { s.classList.toggle('is-aan', n >= +s.getAttribute('data-nj-label')); });
    });
    document.querySelectorAll('[data-nj-wm-aantal]').forEach(function (e) { e.textContent = cart.item_count; });
    document.querySelectorAll('[data-nj-wm-knoptotaal]').forEach(function (e) { e.innerHTML = geld(cart.total_price); });
    kortTitels();
  }
  // "Meer kopen, meer korting: 2+ stuks 10% (-€15,99)" -> "Koop 2: 10% korting (-€15,99)" (in de taal van de bezoeker)
  function kortTitels() {
    var sjabloon = t('korting') || 'Koop [n]: [p]% korting';
    document.querySelectorAll('.cart__discounts .cart__discount').forEach(function (e) {
      if (e.getAttribute('data-nj-kort')) return;
      e.textContent = e.textContent.replace(/Meer kopen, meer korting:\s*(\d)\+ stuks (\d+)%/i, function (m, n, p) { return sjabloon.replace('[n]', n + (n === '4' ? '+' : '')).replace('[p]', p); }).trim();
      e.setAttribute('data-nj-kort', '1');
    });
  }
  function ververs() {
    if (bezig) { opnieuw = true; return; }
    bezig = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(teken)
      .catch(function () {}).then(function () { bezig = false; if (opnieuw) { opnieuw = false; ververs(); } });
  }
  function start() {
    var producten = document.querySelector('#CartDrawer [data-products], [data-location="page"] [data-products]');
    if (producten && 'MutationObserver' in window) new MutationObserver(ververs).observe(producten, { childList: true });
    var kortingen = document.querySelector('#CartDrawer [data-discounts]');
    if (kortingen && 'MutationObserver' in window) new MutationObserver(kortTitels).observe(kortingen, { childList: true, subtree: true });
    ['cart:updated', 'ajaxProduct:added', 'cart:build'].forEach(function (ev) { document.addEventListener(ev, ververs); });
    ververs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
